import { datadogLogs } from '@datadog/browser-logs'
import { time, timeEnd } from '@/utils/time_tracker'

export const init = (clientToken: string, secureCookie: boolean, env: string) => {
  datadogLogs.init({
    site: 'datadoghq.com',
    forwardErrorsToLogs: false, // false に設定すると、console.error ログ、キャッチされない例外、ネットワークエラーは Datadog へ送信されません。
    sampleRate: 100,
  
    clientToken,
    service: 'kCloudWeb',
    useSecureSessionCookie: secureCookie,
    env,
  });
}

export const setTabId = (tabId: string) => {
  datadogLogs.addLoggerGlobalContext('kCloudAppTabId', tabId)
}

export const sessionIdTrancateLength = 8
export const setSessionId = (sessionId: string) => {
  datadogLogs.addLoggerGlobalContext('kCloudApiSessionId', sessionId.substring(0, sessionIdTrancateLength))
}

export const setAccountId = (accountId: string) => {
  datadogLogs.addLoggerGlobalContext('kCloudApiAccountId', accountId);
}

export const setConstructionId = (cloudConstructionId: string) => {
  datadogLogs.addLoggerGlobalContext('kCloudApiConstructionId', cloudConstructionId);
}

export const setKuraemonCloudWebPageVersion = (kCloudWebPageVersion: string) => {
  datadogLogs.addLoggerGlobalContext('kCloudWebPageVersion', kCloudWebPageVersion);
}

export const info = (message: string, messageContext?: object) => {
  if (messageContext) {
    datadogLogs.logger.info(message, messageContext)
    return
  }
  datadogLogs.logger.info(message)
}

export const warn = (message: string, messageContext?: object) => {
  datadogLogs.logger.warn(message, messageContext);
}

export const timeTrack = async (label: string, callbackProc: () => Promise<any>) => {
  try {
    time(label)
    return await callbackProc()
  } finally {
    const end = timeEnd(label)
    if ('elapsedTimeMillis' in end) {
      info(label, { elapsedTimeMillis: end.elapsedTimeMillis })
    }
  }
}
